import Vue from 'vue';

Vue.directive('cursor', {
  bind: ($el: HTMLElement, binding) => {
    $el.style.cursor = binding.value || 'pointer';
  },
});
